// extracted by mini-css-extract-plugin
export default {"wrapper":"CardPride_wrapper__F-p8D","title":"CardPride_title__yNdgU","img":"CardPride_img__DelJK"};